/*CUSTOM JS CODE - COMMENTS WILL EXPLAIN*/

/* ============================================
   PRODUCT CARD SWATCHES (click + hover swap)
   ============================================ */
document.addEventListener('click', function (e) {
  const swatch = e.target.closest('[data-swatch-product]');
  if (!swatch) return;
  e.preventDefault();

  const card = swatch.closest('.product-card');
  if (!card) return;

  // Image
  const img = card.querySelector('.js-card-featured-image');
  if (img) {
    img.removeAttribute('srcset');
    img.removeAttribute('sizes');
    img.src = swatch.dataset.productImage;
  }

  const secondaryImg = card.querySelector('.js-card-secondary-image');
  if (secondaryImg && swatch.dataset.productSecondaryImage) {
    secondaryImg.removeAttribute('srcset');
    secondaryImg.removeAttribute('sizes');
    secondaryImg.src = swatch.dataset.productSecondaryImage;
  }

  // Title + link
  const titleLink = card.querySelector('.product-card__title');
  if (titleLink) {
    titleLink.textContent = swatch.dataset.productTitle;
    titleLink.href = swatch.dataset.productUrl;
  }

  // Media wrapper link
  const mediaLink = card.querySelector('.js-card-media-link');
  if (mediaLink) mediaLink.href = swatch.dataset.productUrl;

  // Price
  const priceEl = card.querySelector('[data-card-price]');
  if (priceEl) priceEl.innerHTML = swatch.dataset.productPrice;

  // Badges
  const badgesEl = card.querySelector('[data-card-badges]');
  if (badgesEl) badgesEl.innerHTML = swatch.dataset.productBadges || '';

  // Colour
  const colourEl = card.querySelector('[data-card-colour]');
  if (colourEl) colourEl.textContent = swatch.dataset.productColour;

  // Quick add (single variant products)
  const variantInput = card.querySelector('.quick-add input[name="id"]');
  if (variantInput) variantInput.value = swatch.dataset.productVariantId;

  const addBtn = card.querySelector('.quick-add button[data-variant-id]');
  if (addBtn) addBtn.dataset.variantId = swatch.dataset.productVariantId;

  // Quick view (multi-variant products)
  const quickViewEl = card.querySelector('quick-view');
  if (quickViewEl) quickViewEl.dataset.productUrl = swatch.dataset.productUrl;

  // Selected state
  card.querySelectorAll('.swatch--square').forEach(s => s.classList.remove('swatch--selected'));
  swatch.classList.add('swatch--selected');
});

function updateCardFields(card, data) {
  const img = card.querySelector('.js-card-featured-image');
  if (img && data.image) {
    img.removeAttribute('srcset');
    img.removeAttribute('sizes');
    img.src = data.image;
  }

  const titleLink = card.querySelector('.product-card__title');
  if (titleLink && data.title) titleLink.textContent = data.title;

  const colourEl = card.querySelector('[data-card-colour]');
  if (colourEl && data.colour) colourEl.textContent = data.colour;

  const priceEl = card.querySelector('[data-card-price]');
  if (priceEl && data.price) priceEl.innerHTML = data.price;

  const badgesEl = card.querySelector('[data-card-badges]');
  if (badgesEl && data.badges !== undefined) badgesEl.innerHTML = data.badges;
}

document.addEventListener('mouseover', function (e) {
  const swatch = e.target.closest('[data-swatch-product]');
  if (!swatch) return;

  const card = swatch.closest('.product-card');
  if (!card) return;

  updateCardFields(card, {
    image: swatch.dataset.productImage,
    title: swatch.dataset.productTitle,
    colour: swatch.dataset.productColour,
    price: swatch.dataset.productPrice,
    badges: swatch.dataset.productBadges
  });
});

document.addEventListener('mouseout', function (e) {
  const swatch = e.target.closest('[data-swatch-product]');
  if (!swatch) return;

  const card = swatch.closest('.product-card');
  if (!card) return;

  const selected = card.querySelector('.swatch--selected');
  if (!selected) return;

  updateCardFields(card, {
    image: selected.dataset.productImage,
    title: selected.dataset.productTitle,
    colour: selected.dataset.productColour,
    price: selected.dataset.productPrice,
    badges: selected.dataset.productBadges
  });
});


/* ============================================
   QUICK VIEW MODAL - COLOUR SWATCH SWAP (AJAX)
   ============================================ */
document.addEventListener('click', function (e) {
  const swatch = e.target.closest('[data-quick-view-swatch]');
  if (!swatch) return;

  const quickView = swatch.closest('.quick-view');
  if (!quickView) return;

  e.preventDefault();

  const content = quickView.querySelector('.quick-view__content');
  if (!content) return;

  fetch(`${swatch.dataset.productUrl}?section_id=main-product-modal`)
    .then(res => res.text())
    .then(html => {
      const temp = document.createElement('div');
      temp.innerHTML = html;
      const newContent = temp.querySelector('.quick-view__content');
      if (newContent) content.innerHTML = newContent.innerHTML;
    });
});


document.addEventListener('click', function (e) {
  const swatch = e.target.closest('.colour-variant-thumb');
  if (!swatch) return;
  if (swatch.closest('.quick-view')) return;
  if (e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey) return;

  try {
    sessionStorage.setItem('sdmn-skip-transition', '1');
  } catch (err) {}
});

/* ============================================
   MARQUEES - CONTINUOUS DRAGGABLE
   Covers Shop the Feed and Product UGC.
   Initialised on load AND on shopify:section:load, so they
   render correctly in the theme editor without needing a save.
   ============================================ */
const MARQUEE_SELECTOR = '.shop-the-feed-marquee, .product-ugc-marquee';

function initMarquee(el) {
  if (el._flkty) return;

  const speed = parseInt(el.dataset.speed) || 16;

  const flkty = new Flickity(el, {
    prevNextButtons: false,
    pageDots: false,
    wrapAround: true,
    freeScroll: true,
    contain: false,
    draggable: true
  });

  el._flkty = flkty;
  flkty.x = 0;

  function play() {
    flkty.x -= speed * 0.1;
    flkty.settle(flkty.x);
    el._raf = requestAnimationFrame(play);
  }

  play();
}

function scanMarquees(root) {
  const scope = root || document;
  scope.querySelectorAll(MARQUEE_SELECTOR).forEach(initMarquee);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => scanMarquees());
} else {
  scanMarquees();
}

document.addEventListener('shopify:section:load', (event) => {
  scanMarquees(event.target);
});

document.addEventListener('shopify:section:unload', (event) => {
  event.target.querySelectorAll(MARQUEE_SELECTOR).forEach((el) => {
    if (el._raf) cancelAnimationFrame(el._raf);
    if (el._flkty) el._flkty.destroy();
  });
});


/* ============================================
   MENU - DROPDOWN/MEGA MENU ANIMATION REMOVAL
   ============================================ */
document.addEventListener('DOMContentLoaded', () => {
  const DetailsDropdown = customElements.get('details-dropdown');
  if (DetailsDropdown) {
    DetailsDropdown.prototype.transitionIn = async function () {
      Motion.animate(this.contentElement, { opacity: [0, 1], visibility: 'visible' }, { duration: 0 });
      const translateY = this.level === 'top' ? '-105%' : '2rem';
      return Motion.animate(this.contentElement.firstElementChild, { transform: [`translateY(${translateY})`, 'translateY(0)'] }, { duration: 0 }).finished;
    };

    DetailsDropdown.prototype.transitionOut = async function () {
      Motion.animate(this.contentElement, { opacity: 0, visibility: 'hidden' }, { duration: 0 });
      const translateY = this.level === 'top' ? '-105%' : '2rem';
      return Motion.animate(this.contentElement.firstElementChild, { transform: `translateY(${translateY})` }, { duration: 0 }).finished;
    };
  }

  const DetailsMega = customElements.get('details-mega');
  if (DetailsMega) {
    DetailsMega.prototype.transitionIn = async function () {
      this.contentElement.querySelector('tabs-element')?.load();
      document.body.classList.add('with-mega');
      Motion.animate(this.contentElement.firstElementChild, { visibility: 'visible', transform: 'translateY(0)' }, { duration: 0 });
    };

    DetailsMega.prototype.transitionOut = async function () {
      document.body.classList.remove('with-mega');
      Motion.animate(this.contentElement.firstElementChild, { visibility: 'hidden', transform: 'translateY(-105%)' }, { duration: 0 });
    };
  }
});


/* ============================================
   MENU - FULL-WIDTH DROPDOWN POSITIONING
   ============================================ */
document.addEventListener('toggle', function (e) {
  const details = e.target.closest('details[is="details-dropdown"]');
  if (!details || details.getAttribute('level') !== 'top') return;
  if (!details.hasAttribute('open')) return;

  const summary = details.querySelector('summary');
  const dropdown = details.querySelector(':scope > .dropdown');
  if (!summary || !dropdown) return;

  const rect = dropdown.getBoundingClientRect();
  dropdown.style.setProperty('--bg-top', `${rect.top}px`);
  dropdown.style.setProperty('--bg-height', `${rect.height}px`);

  const offset = summary.getBoundingClientRect().left;
  dropdown.style.setProperty('--dropdown-offset', `${offset}px`);
}, true);


function initCarousel(track) {
  if (track._flkty) return; // the one true guard — not classList

  const wrapper = track.closest('.product-carousel-marquee');
  const isMobile = window.matchMedia('(max-width: 767px)').matches;
  const columnsVar = isMobile ? '--carousel-columns-mobile' : '--carousel-columns';
  const columns = parseFloat(getComputedStyle(wrapper).getPropertyValue(columnsVar)) || 4;
  const peekFraction = 0.3 / (columns + 0.5);

  const flkty = new Flickity(track, {
    prevNextButtons: false,
    pageDots: false,
    wrapAround: true,
    cellAlign: peekFraction,
    contain: false,
    draggable: !track.hasAttribute('data-no-mobile-drag')
  });

  track._flkty = flkty;
}

function scanInitialCarousels() {
  document.querySelectorAll('.product-carousel-marquee__track').forEach(initCarousel);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', scanInitialCarousels);
} else {
  scanInitialCarousels();
}

// catches AJAX-loaded tabs on the multi-collection section
new MutationObserver((mutations) => {
  mutations.forEach((m) => {
    m.addedNodes.forEach((node) => {
      if (!(node instanceof HTMLElement)) return;
      if (node.matches?.('.product-carousel-marquee__track')) initCarousel(node);
      node.querySelectorAll?.('.product-carousel-marquee__track').forEach(initCarousel);
    });
  });
}).observe(document.body, { childList: true, subtree: true });

// re-measure a carousel when its tab panel becomes visible
new MutationObserver((mutations) => {
  mutations.forEach((m) => {
    if (m.attributeName !== 'hidden') return;
    const panel = m.target;
    if (panel.hasAttribute('hidden')) return;
    panel.querySelectorAll('.product-carousel-marquee__track').forEach((track) => {
      track._flkty?.resize();
    });
  });
}).observe(document.body, { attributes: true, attributeFilter: ['hidden'], subtree: true });

// handles BOTH button patterns: singular section's data-carousel-prev/next,
// and the multi-tab section's is="previous-button"/is="next-button"
document.addEventListener('click', (event) => {
  const dataPrev = event.target.closest('[data-carousel-prev]');
  const dataNext = event.target.closest('[data-carousel-next]');
  const attrPrev = event.target.closest('[is="previous-button"]');
  const attrNext = event.target.closest('[is="next-button"]');

  const prevBtn = dataPrev || attrPrev;
  const nextBtn = dataNext || attrNext;
  const btn = prevBtn || nextBtn;
  if (!btn) return;

  const trackId = btn.getAttribute('data-carousel-prev')
    || btn.getAttribute('data-carousel-next')
    || btn.getAttribute('aria-controls');

  const track = document.getElementById(trackId);
  const flkty = track?._flkty;
  if (!flkty) return;

  prevBtn ? flkty.previous() : flkty.next();
});

// wrapAround means there's always a "previous" — keep it enabled
new MutationObserver((mutations) => {
  mutations.forEach((m) => {
    const btn = m.target;
    if (m.attributeName === 'disabled' && btn.matches?.('[is="previous-button"]')) {
      const track = document.getElementById(btn.getAttribute('aria-controls'));
      if (track?._flkty) btn.disabled = false;
    }
  });
}).observe(document.body, { attributes: true, attributeFilter: ['disabled'], subtree: true });

/* ============================================
   SIZE GUIDE MODAL
   Lives here rather than inline in main-product.liquid so it
   initialises reliably on page load and on theme editor reloads.
   ============================================ */
function initSizeGuide(root) {
  if (root._sizeGuideInit) return;

  const trigger = root.querySelector('.size-guide__trigger');
  const overlay = root.querySelector('.size-guide__overlay');
  const modal = root.querySelector('.size-guide__modal');
  const closeBtn = root.querySelector('.size-guide__close');
  if (!trigger || !overlay || !modal || !closeBtn) return;

  root._sizeGuideInit = true;

  document.body.appendChild(overlay);
  document.body.appendChild(modal);

  function openModal() {
    modal.hidden = false;
    overlay.style.display = 'block';
    document.documentElement.classList.add('size-guide-open');
    document.body.classList.add('size-guide-open');
    closeBtn.focus();
  }

  function closeModal() {
    modal.hidden = true;
    overlay.style.display = 'none';
    document.documentElement.classList.remove('size-guide-open');
    document.body.classList.remove('size-guide-open');
    trigger.focus();
  }

  trigger.addEventListener('click', openModal);
  closeBtn.addEventListener('click', closeModal);
  overlay.addEventListener('click', closeModal);

  modal.addEventListener('click', (e) => {
    if (e.target === modal) closeModal();
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && !modal.hidden) closeModal();
  });
}

function scanSizeGuides(root) {
  (root || document).querySelectorAll('.size-guide').forEach(initSizeGuide);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => scanSizeGuides());
} else {
  scanSizeGuides();
}

document.addEventListener('shopify:section:load', (event) => {
  scanSizeGuides(event.target);
});